'use strict';

var cov_1hm35amat4 = function () {
    var path = '/home/lobo/repos/meetings-app/src/app/components/paginator/paginator.js',
        hash = '3c8fc1731fa2120211f0c9bbfb7ee48e21788355',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/meetings-app/src/app/components/paginator/paginator.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 35
                }
            },
            '1': {
                start: {
                    line: 5,
                    column: 8
                },
                end: {
                    line: 5,
                    column: 41
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 64
                }
            },
            '3': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 9
                }
            },
            '4': {
                start: {
                    line: 11,
                    column: 12
                },
                end: {
                    line: 11,
                    column: 64
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 25
                },
                end: {
                    line: 16,
                    column: 65
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 32
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 23,
                    column: 9
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 12
                },
                end: {
                    line: 22,
                    column: 38
                }
            },
            '9': {
                start: {
                    line: 24,
                    column: 22
                },
                end: {
                    line: 24,
                    column: 47
                }
            },
            '10': {
                start: {
                    line: 25,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 28
                }
            },
            '11': {
                start: {
                    line: 29,
                    column: 8
                },
                end: {
                    line: 29,
                    column: 37
                }
            },
            '12': {
                start: {
                    line: 30,
                    column: 8
                },
                end: {
                    line: 30,
                    column: 44
                }
            },
            '13': {
                start: {
                    line: 31,
                    column: 8
                },
                end: {
                    line: 31,
                    column: 35
                }
            },
            '14': {
                start: {
                    line: 35,
                    column: 0
                },
                end: {
                    line: 43,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 41
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 14
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 8
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 15,
                        column: 4
                    },
                    end: {
                        line: 15,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 15,
                        column: 23
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 15
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 19
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 20
            },
            '4': {
                name: '(anonymous_4)',
                decl: {
                    start: {
                        line: 28,
                        column: 4
                    },
                    end: {
                        line: 28,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 28,
                        column: 19
                    },
                    end: {
                        line: 32,
                        column: 5
                    }
                },
                line: 28
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 9,
                        column: 24
                    },
                    end: {
                        line: 9,
                        column: 63
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 9,
                        column: 24
                    },
                    end: {
                        line: 9,
                        column: 57
                    }
                }, {
                    start: {
                        line: 9,
                        column: 61
                    },
                    end: {
                        line: 9,
                        column: 63
                    }
                }],
                line: 9
            },
            '1': {
                loc: {
                    start: {
                        line: 10,
                        column: 8
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 10,
                        column: 8
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                }, {
                    start: {
                        line: 10,
                        column: 8
                    },
                    end: {
                        line: 12,
                        column: 9
                    }
                }],
                line: 10
            },
            '2': {
                loc: {
                    start: {
                        line: 21,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 21,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                }, {
                    start: {
                        line: 21,
                        column: 8
                    },
                    end: {
                        line: 23,
                        column: 9
                    }
                }],
                line: 21
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0,
            '10': 0,
            '11': 0,
            '12': 0,
            '13': 0,
            '14': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0],
            '2': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginatorController = function () {
    function PaginatorController($stateParams, $location) {
        _classCallCheck(this, PaginatorController);

        cov_1hm35amat4.f[0]++;
        cov_1hm35amat4.s[0]++;

        this.$location = $location;
        cov_1hm35amat4.s[1]++;
        this.$stateParams = $stateParams;
    }

    _createClass(PaginatorController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1hm35amat4.f[1]++;
            cov_1hm35amat4.s[2]++;

            this.pageSize = (cov_1hm35amat4.b[0][0]++, this.collection.$params.page_size) || (cov_1hm35amat4.b[0][1]++, 25);
            cov_1hm35amat4.s[3]++;
            if (this.$stateParams.page) {
                cov_1hm35amat4.b[1][0]++;
                cov_1hm35amat4.s[4]++;

                this.goToPage(parseInt(this.$stateParams.page, 10));
            } else {
                cov_1hm35amat4.b[1][1]++;
            }
        }
    }, {
        key: 'goToPreviousPage',
        value: function goToPreviousPage() {
            cov_1hm35amat4.f[2]++;

            var previous = (cov_1hm35amat4.s[5]++, Math.max(1, this.collection.$page - 1));
            cov_1hm35amat4.s[6]++;
            this.goToPage(previous);
        }
    }, {
        key: 'goToNextPage',
        value: function goToNextPage() {
            cov_1hm35amat4.f[3]++;
            cov_1hm35amat4.s[7]++;

            if (!this.collection.$page) {
                cov_1hm35amat4.b[2][0]++;
                cov_1hm35amat4.s[8]++;

                this.collection.$page = 0;
            } else {
                cov_1hm35amat4.b[2][1]++;
            }
            var next = (cov_1hm35amat4.s[9]++, this.collection.$page + 1);
            cov_1hm35amat4.s[10]++;
            this.goToPage(next);
        }
    }, {
        key: 'goToPage',
        value: function goToPage(page) {
            cov_1hm35amat4.f[4]++;
            cov_1hm35amat4.s[11]++;

            this.collection.$page = page;
            cov_1hm35amat4.s[12]++;
            this.$location.search('page', page);
            cov_1hm35amat4.s[13]++;
            this.collection.$refresh();
        }
    }]);

    return PaginatorController;
}();

cov_1hm35amat4.s[14]++;


angular.module('app').component('paginator', {
    templateUrl: 'app/components/paginator/paginator.html',
    controller: PaginatorController,
    bindings: {
        collection: '<'
    }
});